import { Component, OnInit, Input, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { Subscription } from 'rxjs';
import { TableDefaultConstants } from '../../constants/table.constant';
import { DataTableEventsService } from '../../services/datatable.events.service';

@Component({
  selector: '[lib-header-row]',
  templateUrl: './header-row.component.html',
  styleUrls: ['./header-row.component.css']
})
export class TableHeaderRowComponent implements OnInit, OnChanges {

  @Input() headers:[];
  @Input() defaultSortOptions:object;
  @Input() indexCons;

  sortOptionsSub: Subscription;
  sortOptions: any = TableDefaultConstants.sortOptions;

  constructor(private tableEventsHandler: DataTableEventsService) { }

  ngOnInit() {
    this.sortOptions = { ...this.sortOptions, ...this.defaultSortOptions };
    // console.log('[TableHeaderRow] init sortOptions:', this.sortOptions);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!isNullOrUndefined(changes.defaultSortOptions) && !isNullOrUndefined(this.defaultSortOptions)) {
      this.sortOptions = { ...TableDefaultConstants.sortOptions, ...this.defaultSortOptions };
      // console.log('[TableHeaderRow] updated defaultSortOptions:', this.sortOptions);
    }
  }

  sortHeader(header) {
    if(!isNullOrUndefined(header)){
      let currentSortIndex, currentSortType;
      let currentSortOptions = !isNullOrUndefined(this.sortOptions) ? this.sortOptions : null;
      if(!isNullOrUndefined(currentSortOptions)){
          currentSortIndex = currentSortOptions.sortIndex;
          currentSortType = currentSortOptions.sortType;
      }
      let order = (!isNullOrUndefined(currentSortOptions) && (header.sortIndex == currentSortIndex)) ? (currentSortType == 'asc' ? 'desc' : 'asc')  : 'asc';
      this.sortOptions = { sortIndex : header.sortIndex, sortType: order};
      this.tableEventsHandler.sortOptions.next(this.sortOptions);
    }
  }

  getSortIconClass(header) {
    if(!!header.sortable){
      let sortOptions: any = this.sortOptions;
      if(!isNullOrUndefined(sortOptions)){
          let sortIndex = sortOptions.sortIndex;
          let sortType = sortOptions.sortType;
          if(header.sortIndex == sortIndex && !isNullOrUndefined(sortType)){
            return sortType.toUpperCase() !== 'ASC' ? 'fa fa-arrow-down' : 'fa fa-arrow-up';
        }
      }
      return 'fa fa-sort';
    }else{
      return '';
    }
  }

}
